var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlotsGreyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09292 4L6.90578 4C6.77327 4 6.66602 4.13152 6.66602 4.294L6.66602 15.0393C6.66602 15.2018 6.77327 15.3333 6.90578 15.3333H9.09292C9.22543 15.3333 9.33268 15.2018 9.33268 15.0393L9.33268 4.294C9.33268 4.13152 9.22543 4 9.09292 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4269 0.666748L12.2398 0.666748C12.1073 0.666748 12 0.799347 12 0.963168L12 15.037C12 15.2008 12.1073 15.3334 12.2398 15.3334L14.4269 15.3334C14.5594 15.3334 14.6667 15.2008 14.6667 15.037L14.6667 0.963168C14.6667 0.799347 14.5593 0.666748 14.4269 0.666748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4269 2L2.23977 2C2.10725 2 2 2.13501 2 2.3018L2 15.0315C2 15.1983 2.10725 15.3333 2.23977 15.3333L4.4269 15.3333C4.55941 15.3333 4.66667 15.1983 4.66667 15.0315L4.66667 2.3018C4.66667 2.13501 4.55941 2 4.4269 2Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotsGreyIcon);
export default __webpack_public_path__ + "static/media/PlotsGreyIcon.a3c3043b.svg";
export { ForwardRef as ReactComponent };